/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	getIcepackStateInfoAction,
	createIcepackStateAction,
	updateIcepackStateAction,
	deleteIcepackStateAction,
	resetStateAction,
} from './actions';
import {
	getIsModalShownSelector,
	getIsAuditTabShownSelector,
	getActiveIcepackStateIdSelector,
	getIsIcepackStateInfoLoadingSelector,
	getIcepackStateInfoSelector,
	getIcepackStateNameSelector,
	getIsIcepackStateAddFormOpenSelector,
	getIsIcepackStateCreatingSelector,
	getIsIcepackStateEditFormOpenSelector,
	getIsIcepackStateUpdatingSelector,
	getIsIcepackStateDeletingSelector,
} from './selectors';
import { ICEPACK_STATE_FORM_NAME } from './constants';
import { IcepackStateModalContent } from './components/icepack-state-modal-content';
import { setWindowInfoAction } from '../alert-modal/actions';
import { Audit } from '../../components/audit';
import { getIsAvailableIcepacksStatesButtonsSelector } from '../profile/selectors';
import closeModal from '../../utils/closeModal';
import { removeModalQuery } from '../../utils/removeModalQuery';

const IcepackStateModalWrapper = ({
	isAvailable,
	isModalShown,
	isAuditTabShown,
	onFormSubmit,
	onClearForm,
	onResetState,
	activeIcepackStateId,
	onGetIcepackStateInfo,
	isIcepackStateInfoLoading,
	icepackStateInfo,
	icepackStateName,
	isIcepackStateAddFormOpen,
	onCreateIcepackState,
	isIcepackStateCreating,
	isIcepackStateEditFormOpen,
	onUpdateIcepackState,
	isIcepackStateUpdating,
	onDeleteIcepackState,
	isIcepackStateDeleting,
	onSetWindowInfo,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'icepackStateModalSaga', saga });
	useInjectReducer({ key: 'icepackStateModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		if (activeIcepackStateId) {
			onGetIcepackStateInfo(activeIcepackStateId);
		}
	}, [activeIcepackStateId]);

	const handleNavItemClick = modal => {
		if (modal === 'audit') {
			query.set('tab', 'audit');
		} else {
			query.set('modal', modal);
			query.delete('tab');
		}

		if (mode) {
			query.delete('mode');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);

		onClearForm();
		onResetState();

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackStateFormOpenButtonClick = mode => {
		if (activeIcepackStateId) {
			query.set('id', activeIcepackStateId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onClearForm();
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeIcepackStateId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackStateFormSubmit = async () => {
		await onFormSubmit(ICEPACK_STATE_FORM_NAME);

		if (activeIcepackStateId) {
			onUpdateIcepackState({
				id: activeIcepackStateId,
				searchQuery: removeModalQuery(query.toString()),
				redirect: () => handleIcepackStateFormOpenButtonClick('cancel'),
			});

			return;
		}

		onCreateIcepackState({
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleIcepackStateFormSubmit();
		}
	};

	const handleIcepackStateDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteIcepackState({
						id: activeIcepackStateId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
					}),
			},
		});
	};

	return (
		<ModalWindow
			isLoading={isIcepackStateInfoLoading}
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			navItems={
				isIcepackStateEditFormOpen || isIcepackStateAddFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('icepack_state'),
								isActive: modal === 'icepack_state' && !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			headerText={
				isIcepackStateEditFormOpen || isIcepackStateAddFormOpen
					? `${isIcepackStateEditFormOpen ? 'Изменить состояние' : 'Создать состояние'}`
					: icepackStateName
			}
			modalContent={
				!isAuditTabShown ? (
					<IcepackStateModalContent
						isLoading={isIcepackStateInfoLoading || isIcepackStateDeleting}
						icepackStateInfo={icepackStateInfo}
						isIcepackStateFormOpen={isIcepackStateEditFormOpen || isIcepackStateAddFormOpen}
					/>
				) : (
					<Audit entityName="icepacks_states" entityId={activeIcepackStateId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isIcepackStateEditFormOpen || isIcepackStateAddFormOpen) &&
						isAvailable.delete &&
						!isAuditTabShown
							? [
									{
										onClick: handleIcepackStateDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isIcepackStateInfoLoading || isIcepackStateDeleting,
									},
							  ]
							: []
					}
					rightButtons={
						isIcepackStateEditFormOpen || isIcepackStateAddFormOpen
							? [
									{
										onClick: handleIcepackStateFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isIcepackStateUpdating || isIcepackStateCreating,
										disabled:
											isIcepackStateInfoLoading ||
											isIcepackStateUpdating ||
											isIcepackStateCreating,
									},
									{
										onClick: () => handleIcepackStateFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isIcepackStateUpdating || isIcepackStateCreating,
									},
							  ]
							: [
									...(isAvailable.update && !isAuditTabShown
										? [
												{
													onClick: () => handleIcepackStateFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isIcepackStateInfoLoading || isIcepackStateDeleting,
												},
										  ]
										: []),
									{
										onClick: handleModalClose,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isAvailable: getIsAvailableIcepacksStatesButtonsSelector(),
	isModalShown: getIsModalShownSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	activeIcepackStateId: getActiveIcepackStateIdSelector(),
	isIcepackStateInfoLoading: getIsIcepackStateInfoLoadingSelector(),
	icepackStateInfo: getIcepackStateInfoSelector(),
	icepackStateName: getIcepackStateNameSelector(),
	isIcepackStateAddFormOpen: getIsIcepackStateAddFormOpenSelector(),
	isIcepackStateCreating: getIsIcepackStateCreatingSelector(),
	isIcepackStateEditFormOpen: getIsIcepackStateEditFormOpenSelector(),
	isIcepackStateUpdating: getIsIcepackStateUpdatingSelector(),
	isIcepackStateDeleting: getIsIcepackStateDeletingSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onClearForm: () => reset(ICEPACK_STATE_FORM_NAME),
	onResetState: resetStateAction,
	onGetIcepackStateInfo: getIcepackStateInfoAction,
	onCreateIcepackState: createIcepackStateAction,
	onUpdateIcepackState: updateIcepackStateAction,
	onDeleteIcepackState: deleteIcepackStateAction,
	onSetWindowInfo: setWindowInfoAction,
};

const IcepackStateModal = connect(mapStateToProps, mapDispatchToProps)(IcepackStateModalWrapper);

IcepackStateModalWrapper.propTypes = {
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	isModalShown: PropTypes.bool.isRequired,
	isAuditTabShown: PropTypes.bool.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	activeIcepackStateId: PropTypes.string,
	isIcepackStateInfoLoading: PropTypes.bool.isRequired,
	onGetIcepackStateInfo: PropTypes.func.isRequired,
	icepackStateInfo: PropTypes.array,
	icepackStateName: PropTypes.string.isRequired,
	isIcepackStateAddFormOpen: PropTypes.bool.isRequired,
	onCreateIcepackState: PropTypes.func.isRequired,
	isIcepackStateCreating: PropTypes.bool.isRequired,
	isIcepackStateEditFormOpen: PropTypes.bool.isRequired,
	onUpdateIcepackState: PropTypes.func.isRequired,
	isIcepackStateUpdating: PropTypes.bool.isRequired,
	onDeleteIcepackState: PropTypes.func.isRequired,
	isIcepackStateDeleting: PropTypes.bool.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
};

export default IcepackStateModal;
